import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import { Box } from '@mui/system';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditCartItemDialog = ({open, handleClose, handleEditCartItem, editCartItem}) => {
  const [quantity, setQuantity] = React.useState();
  const [disabled, setDisabled] = React.useState(false);

  React.useEffect(() => {
    const validate = async() => {
      setDisabled(quantity <= 0)
    };
    validate();
  },[quantity]);

  React.useEffect(() => {
    setQuantity(editCartItem.quantity);
  },[editCartItem]);

  const handleSave = async() => {
    handleEditCartItem(editCartItem.itemKey, quantity)
  };
  const handleCloseDialog = async() => {
    handleClose();
  };
  return (
    <div>
      <Dialog open={open} onClose={handleCloseDialog} TransitionComponent={Transition} sx={{width: "100vw"}}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseDialog}><CloseIcon /></IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Edit Item Quantity</Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="Item Key" variant="standard" fullWidth value={editCartItem.itemKey} disabled/></Grid>
            <Grid item xs={12}><TextField label="Item Name" variant="standard" fullWidth value={editCartItem.itemName} disabled/></Grid>
            <Grid item xs={12}><TextField label="Quantity" variant="standard" fullWidth value={quantity} type="number" onChange={(event)=> setQuantity(event.target.value)}/></Grid>
            <Grid item xs={12}><Button autoFocus variant="contained" disabled={disabled} onClick={handleSave} fullWidth>Save</Button></Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default EditCartItemDialog
